import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const StarIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('StarIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M21.96,10.96c-4.92,0-8.92-4-8.92-8.92C13.04,1.47,12.57,1,12,1c-0.57,0-1.04,0.47-1.04,1.04c0,4.92-4,8.92-8.92,8.92
	C1.47,10.96,1,11.43,1,12c0,0.57,0.47,1.04,1.04,1.04c4.92,0,8.92,4,8.92,8.92c0,0.57,0.47,1.04,1.04,1.04
	c0.57,0,1.04-0.47,1.04-1.04c0-4.92,4-8.92,8.92-8.92c0.57,0,1.04-0.47,1.04-1.04C23,11.43,22.53,10.96,21.96,10.96z M12,17.3
	c-1.09-2.32-2.97-4.2-5.3-5.3c2.32-1.09,4.2-2.97,5.3-5.3c1.09,2.32,2.97,4.2,5.3,5.3C14.97,13.09,13.09,14.97,12,17.3z"
    />
  </svg>
);

export default StarIcon;
